<!--出库单查询-->
<template>
	<div class="content">
		<h3>出库单查询</h3>
		<div class="item">
			<el-form ref="form" :inline="true" :model="form" label-width="80px">
				<el-form-item label="时间类型">
					<el-select v-model="form.timestate" placeholder="请选择" >
						<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="起始日期">
					<el-date-picker
						v-model="form.starttime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="终止日期">
					<el-date-picker
						v-model="form.endtime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>

				<el-form-item label="出库单号">
					<el-input v-model="form.odd" placeholder="请输入单号" clearble></el-input>
				</el-form-item>

                <el-form-item label="产品">
					<el-input v-model="form.product" placeholder="请选择产品" :value="form.productnum" @focus="productfocus"></el-input>
					<!--<el-popover
  					placement="right"
  					width="550"
  					trigger="click">
  					<el-table :data="gridData">
						<el-table-column style="text-align: center;" width="80" property="id" label="序号"></el-table-column>
						<el-table-column width="80" property="num" label="产品编号"></el-table-column>
						<el-table-column width="200" property="name" label="产品名称"></el-table-column>
						<el-table-column width="80" property="pr" label="产品品柜"></el-table-column>
						<el-table-column width="80" property="scale" label="包装比例"></el-table-column>
  					</el-table>
  					<el-button slot="reference" style="display: inline-block;width:200px;text-align: left;color: #cecad1;" icon="el-icon-search">选择产品</el-button>
				</el-popover> -->
				</el-form-item>

                <el-form-item label="出库库房">
					<el-select v-model="form.outstore" @change="selChange" @focus="getStore" placeholder="请选择" >
						<el-option
						v-for="item in warehouse"
						:key="item.StoreCode"
						:label="item.StoreName"
						:value="item.StoreCode">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="出库类型">
					<el-select v-model="form.outstate" placeholder="请选择" >
						<el-option
						v-for="item in outstock"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="数码">
					<el-input v-model="form.num" placeholder="请输入数值" clearble></el-input>
				</el-form-item>

        <!--<el-form-item style="width:800px;margin:0 80px;">
					<el-checkbox v-model="form.checked1">只看单据计划量与处理成功数量不一致的单据</el-checkbox>
				</el-form-item>
        <el-form-item style="width:800px;margin:0 80px;">
					<el-checkbox v-model="form.checked2">显示已删除、已覆盖的单据</el-checkbox>
				</el-form-item>
        -->
			</el-form>
			<div class="btn">
				<el-button type="primary" @click="selectQry">查 询</el-button>
                <el-button type="warning">重 置</el-button>
                <el-button type="primary" @click="exportFile">导 出</el-button>
			</div>
			<div class="item">
			<el-table :data="tableData" border >
				<el-table-column prop="Order" align="center" label="出库单号"></el-table-column>
				<el-table-column prop="OutTime" align="center" label="出库时间"></el-table-column>
				<el-table-column prop="OutType" align="center" label="出库类型"></el-table-column>
                <el-table-column prop="ShipperName" align="center" label="发货单位"></el-table-column>
                <el-table-column prop="ShipperId" align="center" label="发货单位编码"></el-table-column>
				<el-table-column prop="ReceiverName" align="center" label="收货单位"></el-table-column>
                <el-table-column prop="ReceiverId" align="center" label="收货单位编码"></el-table-column>
                <el-table-column prop="Status" align="center" label="状态"></el-table-column>
                <el-table-column prop="Remark" align="center" label="备注"></el-table-column>
                <el-table-column prop="OperUser" align="center" label="操作员"></el-table-column>
                <el-table-column prop="AddTime" align="center" label="创建时间"></el-table-column>
				<el-table-column align="center" label="详情" >
					<template slot-scope="scope">
						<el-button type="text" @click="ShowProduct(scope)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background
			@current-change="handleCurrentPageChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="20">
			</el-pagination>
		</div>
		</div>
		<el-dialog
			title="选择产品"
			:visible.sync="dialogVisible"
			width="600px">
			<el-table :data="gridData" highlight-current-row
    @row-click="handleCurrentChange" >
				<el-table-column align="center" width="80" property="DataId" label="序号"></el-table-column>
				<el-table-column align="center" width="80" property="Productcode" label="产品编号"></el-table-column>
				<el-table-column align="center" width="200" property="Productname" label="产品名称"></el-table-column>
				<el-table-column align="center" width="80" property="Shortname" label="产品品柜"></el-table-column>
				<el-table-column align="center" width="80" property="Norms" label="包装比例"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
		<router-view/>
	</div>
</template>

<script>
export default {
	name: 'outListQry',
	data(){
		return {
			dialogVisible: false,
			form: {
				timestate: '', //时间类型
				starttime:'',  //起始时间
				endtime: '',   //结束时间
				odd: '',       //出库单号
				product: '',   //产品名称
				productnum:'', //产品编号
				outstore:'',   //出库库房
				outstate:'',   //出库类型
				num:'',        //数码
				checked1: false,  //单据类型选择
				checked2: false,  //单据类型选择
			},
			//时间类型
			options: [{
				value: 1,
				label: '创建时间'
				}, {
				value: 2,
				label: '更新时间'
			}],
			warehouse: [],
			//出库类型
            outstock: [{
				value: 1,
				label: '销售出库'
			},{
				value: 2,
				label: '调拨出库'
			}],

			outstoreinfo:{
				Order:'',//出库单号
				AddTime:'',//创建时间
				OutType:'',//出库类型
				OutTime:'',//出库时间
				ShipperName:'',//发货单位
				OperUser:'',//操作员
				ReceiverName:'',//收货单位
				Remark:'',//备注
			},
			gridData: [{}],
			current:null,
			tableData: [],
			pageIndex:1,
			pageNum:0,

		}
	},
	methods:{
		selChange(val){


		},
		confirm(){
			this.form.product = this.current.Shortname + this.current.Productname +this.current.Norms;
			this.form.productnum = this.current.Productcode;
			this.dialogVisible = false
		},
		handleCurrentChange(data){
			this.current = data
		},

		productfocus(){
			//	请求产品数据
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params:{
					action:"query",
					cid:user.QyNum
				}
			})
			.then(res=>{
				console.log(res);
				this.gridData=res.DataList;
			})
			this.dialogVisible = true
		},

		getStore(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Store.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
					console.log(res);
					if(res.Code==0){
						this.warehouse=res.DataList;
					}else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})
		},

		handleCurrentPageChange(index){
			this.pageIndex=index;
			this.selectQry()
		},

		selectQry(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/OutListQry.ashx',
				params:{
					action:"OutListQry",
					qry: this.form,
					cid:user.QyNum,
					pageIndex:this.pageIndex
				}
			})
			.then(res=>{
				console.log(res)
				if(res.Code==0){
					this.tableData=res.Data.DataList
					this.pageNum=res.Data.Total
				}else{
					this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})
		},

		ShowProduct(scope){
			if(scope==null){
				this.$message({
            			showClose: true,
            			message:"出库单信息为空。",
            			type: 'warning'
					});
			}
			console.log(scope)
			this.outstoreinfo.Order=scope.row.Order;
			this.outstoreinfo.AddTime=scope.row.AddTime;
			this.outstoreinfo.OutType=scope.row.OutType;
			this.outstoreinfo.OutTime=scope.row.OutTime;
			this.outstoreinfo.ShipperName=scope.row.ShipperName;
			this.outstoreinfo.OperUser=scope.row.OperUser;
			this.outstoreinfo.ReceiverName=scope.row.ReceiverName;
			this.outstoreinfo.Remark=scope.row.Remark;
			this.$router.push({name:"OutListDetails",query: { outstoreinfo: this.outstoreinfo }})
		},

    //导出出库文件
    exportFile(){
      var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/OutListExport.ashx',
				params:{
					qry: this.form,
					cid:user.QyNum
				}
			})
			.then(res=>{
				if(res.Code==0){
          console.log(res.Data)
          // 创建一个隐藏的a标签
          const link = document.createElement('a');
          link.href = res.Data;
          link.download = "出库记录.xlsx";

          // 兼容性处理
          if (document.createEvent) {
            const event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            link.dispatchEvent(event);
          } else {
            link.click();
          }

          // 清理
          setTimeout(() => {
            link.remove();
          }, 100);

				}else{
					this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}
			})

    }
	}

}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 80px;
}
.el-form--inline .el-form-item{
    width:300px;
    margin-bottom: 10px;
}
.el-input,.el-select {
	width:200px;
}
.el-checkbox{
    line-height: 19px;
}
</style>
<style>
.bg-white .el-table__header tr:last-child th {
	background: #F5F7FA;
}
.outListQry-form {
	border: 1px solid #66b1ff;
	padding: 4px 5px;
}
.outListQry-form .el-form-item{
	margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/outListQry.vue